import { Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { Field } from "@models/configurators/field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { IGroup } from "@models/entity-models";

@Kbo(CToken.Group)
export class Group extends UiObject implements IGroup {

    constructor(kom: KbObjectManager) {
        super(kom);
    }

    private _children: UiObject[];
    @Enumerable()
    public get children(): UiObject[] {
        if (!this._children) this._children = [];
        return this._children;
    }
    public set children(val) {
        this._children = val;
    }
    

    /**
     * Fields array has been deprecated.  This readonly property is here for
     * backwards compatibility
     */
    public get fields(): Field[] {
        return this.getChildrenOfType<Field>(CToken.Field);
    }


    // public visible: boolean;
    public showLabel: boolean;

    public addField(): Field {
        let field = new Field(this.$manager);
        this.$manager.addKbObject(field, this);
        this.children.push(field);
        return field;
    }

    public removeField(field: Field) {
        this.$manager.removeKbObject(field);
        this.children.remove(field);
    }

    public getChildrenOfType<T extends UiObject>(...tokens: CToken[]): T[] {
        return this.filterChildren<T>(tokens,
            this.children
        );
    }

    public allowedChildren(rootType: CToken): CToken[] {
        return this.containerChildren(rootType);
    }

    public ignoredProperties(): string[]{
        return ["fields"];
    }
}
